// extracted by mini-css-extract-plugin
export default {"profile":"Profile_profile__lf3K5","options":"Profile_options__lsUvO","roundel":"Profile_roundel__KyrQo","profileRoundel":"Profile_profileRoundel__05J0R"};